<div
  class="dropzone flex h-full items-center justify-center"
  ptFileUploadDropzone
  [class.hovering]="isHovering"
  (hovered)="toggleHover($event)"
  (dropped)="fileDropped($event)"
>
  <input type="file" multiple #fileInput (change)="startUpload($event)" />

  <div
    class="content layout-padding"
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <ng-content></ng-content>
    @if (label()) {
      <p class="mat-caption">{{ label() }}</p>
    }
    <button mat-stroked-button (click)="fileInput.click()">
      <div class="button-inner" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon>cloud_upload</mat-icon>
        Choose a file...
      </div>
    </button>
  </div>
</div>
